import { toast } from 'react-toastify'
import { DEFAULT_TOAST_OPTIONS } from './toast.config'

export const showErrorToast = (message: string) =>
    toast.error(message, DEFAULT_TOAST_OPTIONS)

export const showSuccessToast = (message: string) =>
    toast.success(message, DEFAULT_TOAST_OPTIONS)

export const showInfoToast = (message: string) =>
    toast.info(message, DEFAULT_TOAST_OPTIONS)
